import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  Button
} from '../../components';

import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import firstImage from './1.png';
import secondImage from './2.png';
import thirdImage from './3.png';

import css from './FaqHelperPage.module.css';
import image from './about-us-1056.jpg';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

let link

if(typeof window !== "undefined"){
  link = `${window.location.protocol}//${window.location.host}/signup-helper`
}


const FaqHelperPage = (props) => {
  
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const classes = useStyles();

  // prettier-ignore
  return (
    <StaticPage
      title="FAQ for helpers"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FaqHelpersPage',
        description: 'FAQ fo helpers',
        name: 'FAQ fo helpers',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
            <div className={css.pageWrapper}>
          <div className={css.fingertipsSection}>
          <h1>Flexible work at your fingertips. </h1>
          <p>You're probably reading this while getting through your Anki deck and eating leftovers from last night. We get it - you're busy. You're worried about all the school debt and want some side income to pay for a night out with friends or for groceries (to upgrade from that ramen).</p>
          <p> 
AppBuddy is here to help. You got into a school that someone is hoping to get into. Help them while making some side income.
        </p>
          </div>


    <div className={css.becomeAHelper}>
            <div className={css.earnMoneyTitle}>
              
            <h1 className={css.earnTitle}>Earn money as a student.</h1>
            <a className={css.earnButtonWrap} href={link}>
              <Button  className={css.earnButton}>Get started</Button>
              </a>
            </div>
      <div className={css.steps}>
        <div className={css.step}>
          <img className={css.bossImage} src={firstImage} />
          <h2 className={css.stepTitle}>
          Be your own boss
          </h2>
          <p>
          Work when and how you want; have the option to offer services in 5+ categories. No long term commitment necessary. 
          </p>
        </div>

        <div className={css.step}>
        <img className={css.bossImage} src={secondImage} />
          <h2 className={css.stepTitle}>
          Set your own rates
          </h2>
          <p>
          You keep 100% of what you charge! No listing fees, no monthly costs to you. Hassle free payments via options like Venmo.
          </p>
        </div>

        <div className={css.step}>
        <img className={css.bossImage} src={thirdImage} />
          <h2 className={css.stepTitle}>
          Convenient
          </h2>
          <p>
          We make the whole process easy,  connecting you directly with students — so you can focus on being a med/dental student.
          </p>
       </div>
      </div>
     </div>


     <div className={css.becomeAHelper}>
            <h1>Becoming a Helper in 3 steps:</h1>

      <div className={css.steps1}>
        <div className={css.step}>
        <div className={css.circle}>
        <p>1</p>
    </div>
          <p>
          Tell us about yourself and select what services you want to offer.          </p>
        </div>

        <div className={css.step}>
        <div className={css.circle}>
        <p>2</p>
      </div>
          <p>
          Choose your own schedule and prices. We're there to help along the way.          </p>
        </div>

        <div className={css.step}>
        <div className={css.circle}>
        <p>3</p>
    </div>
          <p>
          Once the team verifies your application, your profile will go live!          </p>
       </div>
      </div>
     </div>



          <div className={css.faqWrapper}>
          <h1 className={css.pageTitle}>FAQ for helpers </h1>

          <div className={css.contentWrapper}>
          
               


            <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>
                   <h2 className={css.questionStyle}>
                    What services can I provide as a Helper?
                    </h2></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography >
          <p className={css.answerStyle}>
                    <h2 className={css.questionStyle}> You can offer any service you want to, including but not limited to:</h2> 
                    <h2 className={css.questionStyleItem}>⦁	consultation</h2>
                    <h2 className={css.questionStyleItem}>⦁	personal statement brainstorm</h2>
                    <h2 className={css.questionStyleItem}>⦁	personal statement editing</h2>
                    <h2 className={css.questionStyleItem}>⦁	secondary statement editing</h2>
                    <h2 className={css.questionStyleItem}>⦁	mock interview</h2>

                    </p>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}><h2 className={css.questionStyle}>
                    How long does it take for my registration to be processed?
                    </h2></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <h2 className={css.questionStyle}> It takes 3-5 business days to process your information. If we need any additional information from you, we'll be in touch! </h2>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}> <h2 className={css.questionStyle}>                     
                  What's required to become a Helper?
                  </h2></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <p className={css.answerStyle}>
          <h2 className={css.questionStyleItem}>⦁	Be at least 18 years old.</h2>
          <h2 className={css.questionStyleItem}>⦁	Consent to an ID check. This helps keep our platform safe for all our users.</h2>
          <h2 className={css.questionStyleItem}>⦁	Must be enrolled in a graduate program in the United States or Canada.</h2>
          <h2 className={css.questionStyleItem}>⦁	Must be able to provide proof of schools that you received acceptances to or schools you received interviews at.</h2>

           </p>
           </Typography>
        </AccordionDetails>
      </Accordion>


      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}> <h2 className={css.questionStyle}>
                    How do I increase requests from students?
                    </h2></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <h2 className={css.questionStyle}>
                    If you aren't receiving as many requests as you'd like, consider adjusting your profile. Feel free to adjust your rates and/or the services you're offering.  </h2>
        </Typography>
        </AccordionDetails>
      </Accordion>


      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}> <h2 className={css.questionStyle}>
                     I have a question that's not listed. Who do I contact?
                    </h2></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <h2 className={css.questionStyle}>
                    Please email info@theappbuddy.com with any questions! We're excited to here from you.</h2>
        </Typography>
        </AccordionDetails>
      </Accordion>

    </div>





          </div>
          </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FaqHelperPage;
